export default "__VITE_ASSET__B$GlwiUx__"